/**
 * Utility functions for working with Nhost Storage URLs
 */

/**
 * Creates a public URL for a Nhost file using the file ID
 * @param {string} fileId - The file ID from Nhost storage
 * @returns {string} - The public URL for the file
 */
export const getPublicUrl = (fileId) => {
  if (!fileId) return null;
  
  // If it's already a full URL, return it as is
  if (fileId.startsWith('http')) {
    return fileId;
  }

  // If it's a relative URL (starts with /api), it's using our local fallback
  if (fileId.startsWith('/api')) {
    return fileId;
  }
  
  // Extract subdomain and region from environment if available
  const subdomain = process.env.REACT_APP_NHOST_SUBDOMAIN || 'gtwosmwmvopoqrodakmd';
  const region = process.env.REACT_APP_NHOST_REGION || 'eu-central-1';
  
  // Construct the proper Nhost storage URL
  return `https://${subdomain}.storage.${region}.nhost.run/v1/files/${fileId}`;
};

export default {
  getPublicUrl
}; 